import { colors, fonts, fontSizes, measurements, BREAKPOINTS } from 'theme'
import css from 'styled-jsx/css'

const MENU_SIZE_EXPANDED = "13.875rem"
const MENU_SIZE_COLLAPSED = "3.75rem"

export const menu = css`
  nav {
    background-color: ${colors.frame};
    min-height: calc(100vh);
    z-index: 101;
    transition: width 0.3s ease;
  }

  nav.expanded {
    width: ${MENU_SIZE_EXPANDED};
  }

  nav.collapsed {
    width: ${MENU_SIZE_COLLAPSED};
  }

  nav > header {
    height: ${measurements.headerHeight};
    background-color: ${colors.darkFrame};
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0 0.75rem;
    gap: 0.5rem;
  }

  .header-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0.5rem;
    border-radius: 4px;
  }

  .header-toggle:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  nav > header :global(.logo-link) {
    display: flex;
    align-items: center;
  }

  nav > header :global(.logo) {
    max-width: 4rem;
  }

  .menus {
    list-style: none;
    padding: 0;
    transition: width 0.3s ease;
  }

  .menus.expanded {
    width: ${MENU_SIZE_EXPANDED};
  }

  nav.collapsed .menus {
    width: ${MENU_SIZE_COLLAPSED};
  }

  .menus :global(li) {
    height: 2.5rem;
    align-items: center;
    display: flex;
    font-size: ${fontSizes.small};
    color: ${colors.white};
  }

  .menus :global(li a) {
    cursor: pointer;
    width: 100%;
    height: 100%;
  }

  .menus :global(li:hover) {
    background-color: ${colors.darkFrame};
  }

  .menus :global(li::before) {
    content: '';
    width: 0.25rem;
    height: 100%;
  }

  .menus :global(li:hover::before) {
    background-color: ${colors.secondary};
  }

  .menus :global(li i) {
    margin: 0.5rem;
    margin-left: 0.75rem;
  }

  nav.collapsed .menus :global(li i) {
    margin: 0 auto;
  }

  nav.collapsed .menus :global(li) {
    justify-content: center;
  }

  nav.collapsed .menus :global(li::before) {
    display: none;
  }

  .actions {
    margin: 0.75rem 0.75rem 0;
  }

  .hideOnMobile {
    display: block;
  }

  .hideOnLarge {
    display: none;
  }

  @media screen and (max-width: ${BREAKPOINTS.LG}) {
    .hideOnMobile {
      display: none;
    }

    .hideOnLarge {
      display: block;
    }

    nav > header,
    nav {
      background-color: ${colors.frame};
    }
    nav {
      height: ${measurements.headerHeight};
      position: fixed;
    }
    nav.collapsed {
      width: 0;
    }
    nav.collapsed  ul {
      display: none;
    }
    .menus.expanded {
      height: 100%;
      max-height: calc(100vh - 15rem);
      overflow-y: auto;
      padding-bottom: 2rem;
    }
  }
`

export const version = css`
p {
  color: ${colors.white};
  max-width: ${MENU_SIZE_EXPANDED};
}
`

export const menuItem = css`
  .menu-item {
    display: flex;
    align-items: center;
    position: relative;
  }
  .is-new, .is-beta {
    font-size: 0.7rem;
    background: ${colors.badge};
    position: absolute;
    left: 8px;
    width: fit-content;
    border-radius: 4px;
    padding: 0.2rem;
  }
  .is-beta {
    background: ${colors.warning};
  }
`

export const menuGlobalStyles = css.global`
  nav .parent-menu-item {
    height: 40px;
    display: flex;
    align-items: center;
    color: ${colors.white};
    padding-left: 12px;
    font-size: ${fontSizes.small};
    cursor: pointer;
    position: relative;
  }
  nav .parent-menu-item:hover {
    background-color: ${colors.darkFrame};
  }
  nav .parent-menu-item.collapsed {
    justify-content: center;
    padding-left: 0;
  }
  nav .parent-icon {
    margin-right: 8px;
  }
  nav .parent-menu-item.collapsed .parent-icon {
    margin-right: 0;
  }
  nav .chevron-icon {
    margin-left: auto;
    margin-right: 8px;
  }
  nav .padded {
    padding-left: 1rem;
  }
  nav .submenu-items {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;
  }
  nav .submenu-items.open {
    max-height: 500px;
  }
  nav .is-new, .is-beta {
    font-size: .7rem;
    background: ${colors.badge};
    position: absolute;
    left: 8px;
    width: fit-content;
    border-radius: 4px;
    padding: 0.2rem;
  }
  nav .is-beta {
    background: ${colors.secondary};
  }
  nav .logo {
    max-width: 3.25rem;
  }
`
